import { render, staticRenderFns } from "./BetonKorisnikCRUD.vue?vue&type=template&id=05118e86&"
import script from "./BetonKorisnikCRUD.vue?vue&type=script&lang=js&"
export * from "./BetonKorisnikCRUD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports